var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expand-transition",
    [
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.open,
              expression: "open",
            },
          ],
          staticClass: "rounded-0",
          attrs: { outlined: "" },
        },
        [
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(
                "v-simple-table",
                { staticClass: "house-table", attrs: { dense: "" } },
                [
                  [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.documentNumber")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.shipper")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.consignee")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.clientFm")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.clientTo")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.billOfLading")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.freightTerms")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-left text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.equipment")))]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "text-center text-caption text--secondary font-weight-medium",
                          },
                          [_vm._v(_vm._s(_vm.$t("label.praticaActions")))]
                        ),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.houses, function (house, i) {
                        return _c("tr", { key: i }, [
                          _c(
                            "td",
                            { staticClass: "font-weight-bold primary--text" },
                            [_vm._v(_vm._s(house.documentNbr))]
                          ),
                          _c("td", [_vm._v(_vm._s(house.shipperName || "-"))]),
                          _c("td", [
                            _vm._v(_vm._s(house.consigneeName || "-")),
                          ]),
                          _c("td", [_vm._v(_vm._s(house.clientFrom || "-"))]),
                          _c("td", [_vm._v(_vm._s(house.clientTo || "-"))]),
                          _c("td", [_vm._v(_vm._s(house.billOfLading || "-"))]),
                          _c("td", [_vm._v(_vm._s(house.freightTerms || "-"))]),
                          _c("td", [
                            _vm._v(_vm._s(_vm.equipmentList(house) || "-")),
                          ]),
                          _c(
                            "td",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    icon: "",
                                    "x-small": "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToHouseBL(house)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { "x-small": "" } }, [
                                    _vm._v("mdi-eye"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }